<template>
  <div>
    <vue-action-buttons :buttons="actionButtons" />

    <!-- <div class="row justify-content-end">
      <div class="col-auto">
        <button class="btn" @click="$router.push({ name: 'orders-items-create' })">
          Creer un element
        </button>
      </div>
    </div> -->
    <vue-data-table :headers="headers" :data="orderItems" :items-per-page="10" :buttons="buttons"
      :summable-columns="summableColumns">
      <template #cell-priceTTC="{ row }">
        <span class="px-2 py-1 rounded " v-show="$userRole != 'Magasinier'"
          :class="row.priceTTC > 0 ? 'bg-light-primary text-primary' : 'bg-light-danger text-danger'">
          {{ row.priceTTC }}
        </span>
      </template>


      <template #cell-totalPriceTTC="{ row }">
        <span class="px-2 py-1 rounded " v-show="$userRole != 'Magasinier'"
          :class="row.totalPriceTTC > 0 ? 'bg-light-primary text-primary' : 'bg-light-danger text-danger'">
          {{ row.totalPriceTTC }}
        </span>
      </template>

      <template #footer-totalPriceTTC="{ column, sum }">
        <span v-show="$userRole != 'Magasinier'" class="fw-bold text-success">
          {{ sum }}
        </span>
      </template>

    </vue-data-table>
    <br />
    <div class="row">
      <div class="col-xl-3 col-12">
        <label for="">Client <span class="text-danger">*</span> </label>

        <!-- <vue-select :options="customers" v-model="order.customer_reference"
          @input="onCustomerChangeSelected(order.customer_reference)" placeholder="Select an option"
          labelColumn="society" valueColumn="reference" /> -->

          <vue-select
  :options="customers"
  v-model="order.customer_reference"
  labelColumn="fullName"
  valueColumn="reference"
  :rowClass="row => row.seller_reference ? 'text-primary fw-bold' : ''"
   @input="onCustomerSelected"
>
  <!-- OPTION TEMPLATE -->
  <template #option="{ option }">
    <div class="d-flex justify-content-between align-items-center">
      <span>
        {{ option.fullName }}
        <span
          v-if="option.seller_reference"
          class="badge bg-primary ms-2"
        >
          Vendeur
        </span>
      </span>
    </div>
  </template>
</vue-select>



      </div>

      <div class="col-xl-3 col-12">
        <label for="">Date de commande<span class="text-danger">*</span></label>
        <input type="date" v-model="order.date" class="form-control" />
      </div>



    </div>
    <br>
    <div class="row">
      <div class="col-xl-4 col-12">
        <label for="">
          Adresse de facturation
        </label>
        <textarea v-model="order.billingAddress" class="form-control"></textarea>
      </div>

      <div class="col-xl-4 col-12">
        <label for="">
          Adresse de livraison
        </label>
        <textarea v-model="order.shippingAddress" class="form-control"></textarea>
      </div>

      <div class="col-xl-4 col-12">
        <label for="">
          Remarque
        </label>
        <textarea v-model="order.remark" class="form-control"></textarea>
      </div>
    </div>

    <br />
    <div class="row mt-3 justify-content-between align-items-center">
      <div class="col-xl-8 col-12">

      </div>
      <div class="col-xl-auto col-12">
        <button class="btn btn-success" @click="save(order)">
          <i class="bi bi-check-square-fill"></i> Enregistrer
        </button>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-12">
        (<span class="text-danger">*</span>) : Ce champ est obligatoire.
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      order: {
        date: new Date(new Date().setFullYear(new Date().getFullYear()))
          .toLocaleString("en-CA")
          .split(",")[0],

        amountPaid: 0,
        billingAddress: "",
        shippingAddress: "",
        remark: "",
      },
      accept: false,
      selectedCustomer: {},
      actionButtons: [
        {
          label: "Modifier les articles",
          class: "btn btn-outline-success",
          icon: "bi bi-check2-square",
          action: () => this.$router.push({ name: 'orders-items-create' }),
        },
        {
          label: "Actualiser",
          class: "btn btn-outline-dark",
          icon: "bi bi-arrow-clockwise",
          action: this.refresh,
        },
      ],

      headers: [
        { field: 'itemFullName', label: 'Désignation', class: '' },
        { field: 'priceTTC', label: 'Prix', class: 'fw-bold' },
        { field: 'quantity', label: 'Quantité', class: 'fw-bold' },
        { field: 'totalPriceTTC', label: 'Total', class: 'fw-bold' },
        { field: 'userFullName', label: 'Créer par', class: '' },
      ],
      // Button actions
      buttons: [
        {
          label: 'Modifier',
          icon: 'bi bi-pencil',
          class: 'btn btn-warning',
          action: (item) => {
            this.editItem(item);
          },
        },
        {
          label: 'Supprimer',
          icon: 'bi bi-trash',
          class: 'btn btn-danger',
          action: (item) => {
            this.deleteItem(item);
          },
        },
      ],
      // Columns to summarize
      summableColumns: [
        { field: 'totalPriceTTC', class: 'tfw-bold' },
        { field: 'quantity', class: 'fw-bold' },
      ],
    };
  },
  computed: {
    ...mapGetters("order", {
      orderItems: "getItems",

    }),
    ...mapGetters("customer", {
      customers: "getAll",
    }),

    customersFormatted() {
    return this.customers.map(c => ({
      ...c,
      displayLabel: c.seller_reference
        ? `${c.fullName}  —  (Vendeur : ${c.seller_reference})`
        : c.fullName
    }));
  }
  },
  methods: {
    async save(data) {
      await this.$store.dispatch("order/store", data);
    },
    async refresh() {
      this.$store.dispatch("order/getAllItems");
    },

   onCustomerSelected(reference) {
    // trouver le customer sélectionné
    const customer = this.customers.find(c => c.reference === reference);

    if (!customer) {
      this.order.seller_reference = null;
      return;
    }

    // si le client a un vendeur → on le set
    if (customer.seller_reference) {
      this.order.seller_reference = customer.seller_reference;
    } else {
      this.order.seller_reference = null;
    }
  }
  },
  async beforeMount() {
    await this.$store.dispatch("order/getAllItems");
    await this.$store.dispatch("customer/getAll");
    // (await !this.numberItems)
    //   ? (await this.$store.dispatch("notification/store", {
    //       status: "error",
    //       message: "Aucun élément n'est ajouté. Veuillez en ajouter.",
    //     }),
    //     await this.$router.push({ name: "orders-items-create" }))
    //   : "";
  },
};
</script>
